import React from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';

import RouteLink from '@ivy/components/atoms/RouteLink';
import { ArrowRightIcon } from '@ivy/components/icons';

const OrgSurveyCta = () => {
	return (
		<Box
			sx={{
				position: 'relative',
			}}
		>
			<Box
				sx={{
					// Full bleed
					width: '100vw',
					position: 'absolute',
					left: '50%',
					right: '50%',
					ml: '-50vw',
					mr: '-50vw',
					height: '100%',
					zIndex: -1,
					bgcolor: 'primary.main',
				}}
			/>
			<Stack
				sx={{
					display: 'flex',
					alignItems: 'center',
					py: 4,
				}}
				spacing={4}
			>
				<Typography
					variant='h3'
					component='h2'
					align='center'
					color='primary.contrastText'
				>
					Are you an employer?
				</Typography>
				<Typography variant='body1' align='center' color='primary.contrastText'>
					Update your profile using the form below.
				</Typography>
				<Button
					variant='contained'
					color='whiteButton'
					component={RouteLink}
					to={RouteLink.routes.ACEP_ORG_SURVEY_CREATE}
					sx={{
						color: 'primary.main',
					}}
					size='large'
					endIcon={<ArrowRightIcon />}
				>
					Employer Questionnaire
				</Button>
			</Stack>
		</Box>
	);
};

export default OrgSurveyCta;
